let promise;

export default function ($http) {
    if (!promise) {
        promise = $http.get('api/codes/vehiclesourced');
    }

    return promise.then(result => result.data);
}



// WEBPACK FOOTER //
// ./Client/app/common/services/vehicleSourced.js